/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: voicemailSettingsUtils.ts
 🗓️ Created: 2026-05-02
 🧩 Description:
    Implementation of the Voicemail Settings module.
────────────────────────────────────────────────────────────────*/


export const selectorValueFromLocale = (locale: string): string => {
    if (!locale) return '';
    return locale.replace('_', '-').toLowerCase();
};

export const localeFromSelectorValue = (value: string, fallback: string): string => {
    if (!value) return fallback;
    const parts = value.split('-');
    if (parts.length >= 2) {
        const lang = (parts[0] ?? '').toLowerCase();
        const region = (parts[1] ?? '').toUpperCase();
        if (lang && region) return `${lang}_${region}`;
        if (lang) return lang;
    }
    return value.replace('-', '_') || fallback;
};

export const EMAIL_DATE_FORMAT_OPTIONS: Array<{ value: string; label: string }> = [
    { value: '%A, %B %d %Y, %R',          label: 'Weekday, Month DD YYYY, 24h — %A, %B %d %Y, %R' },
    { value: '%a %d %b %Y %H:%M',          label: 'Short weekday DD Mon YYYY, 24h — %a %d %b %Y %H:%M' },
    { value: '%m/%d/%Y %I:%M %p',          label: 'US style MM/DD/YYYY, 12h — %m/%d/%Y %I:%M %p' },
    { value: '%Y-%m-%d %H:%M',             label: 'ISO date, 24h — %Y-%m-%d %H:%M' },
    { value: '%d/%m/%Y %H:%M',             label: 'EU style DD/MM/YYYY, 24h — %d/%m/%Y %H:%M' },
    { value: '%d-%b-%Y %I:%M %p',          label: 'DD-Mon-YYYY, 12h — %d-%b-%Y %I:%M %p' },
    { value: '%Y-%m-%dT%H:%M:%S%z',        label: 'ISO8601 with timezone — %Y-%m-%dT%H:%M:%S%z' },
    { value: '%A %d %B %Y %H:%M:%S',       label: 'Full weekday + month, 24h with seconds — %A %d %B %Y %H:%M:%S' },
    { value: '%x %X',                      label: 'Locale default date & time — %x %X' },
    { value: '%a %d %b %Y %I:%M:%S %p',   label: 'Short weekday + 12h with seconds — %a %d %b %Y %I:%M:%S %p' },
];
